module.exports = __webpack_public_path__ + "static/f3-6f1cf0cd2d10b4fa10032e783aa5626e.jpg";